import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import { useStyles } from "./OverallTimetableBody.css";
import { formatTime } from "../../../../../Components/FormatTime/FormatTime";

class OverallTimetableBody extends Component {
  render() {
    const { classes, times } = this.props;
    return (
      <Paper className={classes.root}>
        <TableContainer>
          <Table>
            <TableBody>
              {times.map((week, index) => (
                <TableRow key={index} align="center">
                  <TableCell
                    align="center"
                    style={{ fontSize: 16, fontWeight: "bold" }}
                  >
                    {week.weekName}
                  </TableCell>
                  {week.subjects.map((subject, index) => (
                    <TableCell key={index} align="center">
                      <div style={{ fontWeight: "bold" }}>
                        {subject.subjectName}
                      </div>
                      {subject.from && subject.to ? (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          ({formatTime(subject.from)} - {formatTime(subject.to)}
                          )
                        </div>
                      ) : (
                        <div>N/A</div>
                      )}
                      <div
                        className={classes.tooltip}
                        onClick={() =>
                          this.props.history.push(
                            `/administration/staffs/detail/${subject.classTeacherId}`
                          )
                        }
                      >
                        {subject.classTeacherName}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(withRouter(OverallTimetableBody));
